// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "../../../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import ReactAutocomplete from "react-autocomplete";
import * as ButtonUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PricingDashboardDataMachine from "../../../pricing-dashboard/app/PricingDashboardDataMachine.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function getGeoRegionFromId(id, geoRegionList) {
  var res = List.filter(function (region) {
          return region.id === id;
        })(geoRegionList);
  return Belt_List.get(res, 0);
}

function getStoredGeoRegion(geoRegionList) {
  var stored_geo_region_id = localStorage.getItem("selected_geo_region_id");
  if (stored_geo_region_id === null) {
    return ;
  }
  var id = Belt_Int.fromString(stored_geo_region_id);
  if (id !== undefined) {
    return getGeoRegionFromId(id, geoRegionList);
  }
  
}

function GeoRegionListCmp(Props) {
  var state = Props.state;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = React.useState(function () {
        return -1;
      });
  var updateSelectedGeoRegionId = match$1[1];
  React.useEffect((function () {
          PricingDashboardDataMachine.fetchGeoRegions((function (available_geo_regions) {
                  var found_geo_region = getStoredGeoRegion(available_geo_regions);
                  if (found_geo_region !== undefined) {
                    Curry._1(dispatch, {
                          TAG: /* UpdateSelectedGeoRegion */2,
                          selected_geo_region: found_geo_region
                        });
                  }
                  return Curry._1(dispatch, {
                              TAG: /* SetGeoRegionList */1,
                              geo_regions: {
                                TAG: /* Live */1,
                                _0: available_geo_regions
                              }
                            });
                }), (function (error) {
                  return Curry._1(dispatch, {
                              TAG: /* SetGeoRegionList */1,
                              geo_regions: {
                                TAG: /* Error */2,
                                _0: error
                              }
                            });
                }), country);
          
        }), []);
  React.useEffect((function () {
          var match = state.selected_geo_region;
          if (match !== undefined) {
            Curry._1(dispatch, {
                  TAG: /* UpdateCurrentView */8,
                  current_view: /* VehicleListView */2
                });
            return ;
          }
          
        }), [state.selected_geo_region]);
  var dropDownOnClickHandler = function (selected_geo_region) {
    return Belt_Option.mapWithDefault(selected_geo_region, undefined, (function (param) {
                  document.getElementById("geo-region-selector");
                  
                }));
  };
  var getGeoRegionComponentList = function (geo_regions) {
    return React.createElement("div", {
                className: "geo-regions"
              }, Belt_Array.map(Belt_List.toArray(geo_regions), (function (region) {
                      return React.createElement("span", {
                                  key: String(region.id)
                                }, React.createElement(RoundedPrimaryButton$Catalyst.make, {
                                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                            TAG: /* Custom */1,
                                            _0: (function (param) {
                                                return React.createElement("p", {
                                                            className: "geo-region-text"
                                                          }, region.name);
                                              })
                                          }, undefined, (function (param) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* UpdateSelectedGeoRegion */2,
                                                          selected_geo_region: region
                                                        });
                                            }), undefined, undefined, undefined, undefined, "geo-region", undefined, undefined)
                                    }));
                    })));
  };
  var regions = state.geo_regions;
  if (typeof regions === "number") {
    return React.createElement(CircularLoader$Catalyst.make, {});
  }
  switch (regions.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var regions$1 = regions._0;
        var selected_geo_region = getGeoRegionFromId(match$1[0], regions$1);
        return React.createElement("div", {
                    className: "ald-geo-region"
                  }, React.createElement("div", {
                        className: "geo-region-filter"
                      }, React.createElement(ReactAutocomplete, {
                            items: Belt_List.toArray(regions$1),
                            getItemValue: (function (a) {
                                return String(a.id);
                              }),
                            renderItem: (function (a) {
                                return React.createElement("div", {
                                            key: String(a.id),
                                            className: "autosuggest-suggestion"
                                          }, a.name);
                              }),
                            value: selected_geo_region !== undefined ? selected_geo_region.name : "",
                            onSelect: (function (id) {
                                Curry._1(updateSelectedGeoRegionId, (function (param) {
                                        return Caml_format.caml_int_of_string(id);
                                      }));
                                dropDownOnClickHandler(getGeoRegionFromId(Caml_format.caml_int_of_string(id), regions$1));
                                return Curry._1(dispatch, {
                                            TAG: /* UpdateSelectedGeoRegion */2,
                                            selected_geo_region: getGeoRegionFromId(Caml_format.caml_int_of_string(id), regions$1)
                                          });
                              }),
                            onChange: (function ($$event) {
                                
                              }),
                            inputProps: {
                              placeholder: "Select Geo Region",
                              id: "geo-region-selector"
                            }
                          })), React.createElement("div", {
                        className: "geo-regions-container"
                      }, React.createElement("div", {
                            className: "geo-region-helper-string-container"
                          }, React.createElement("p", undefined, "or, Pick your Geolocation")), React.createElement("div", {
                            className: "geo-regions"
                          }, getGeoRegionComponentList(regions$1))));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: regions._0
                  });
    
  }
}

var make = GeoRegionListCmp;

export {
  getGeoRegionFromId ,
  getStoredGeoRegion ,
  make ,
  
}
/* react Not a pure module */
